"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionProvider = void 0;
const ramda_1 = require("ramda");
const eval_1 = require("./eval");
const provider_1 = require("./provider");
const utils_1 = require("./utils");
const operandExp = /\{[\d\w./]+\}/g;
class ExpressionProvider extends provider_1.BaseProvider {
    static create(template) {
        const matches = template.match(operandExp);
        if (matches === null) {
            throw new Error("invalid template");
        }
        const refs = matches.map(str => ({
            exp: new RegExp(str),
            path: str.slice(1, -1).split("/")
        }));
        return new ExpressionProvider({ template, refs });
    }
    merge(props) {
        return new ExpressionProvider({ ...this.props, ...props });
    }
    async evaluate({ rootCtx, ctx }) {
        let { template = "" } = this.props;
        const { refs = [] } = this.props;
        for (const ref of refs) {
            const path = (0, utils_1.resolvePath)(ctx.path, ref.path);
            const value = (0, ramda_1.path)(path, ctx.root);
            if (value === undefined) {
                return [ctx.path, undefined];
            }
            const hasErrors = rootCtx.errors.find(error => (0, ramda_1.equals)((0, utils_1.isLogItemWithPath)(error) && error.path, path));
            if (hasErrors) {
                return [ctx.path, undefined];
            }
            if (typeof value === "object") {
                template = template.replace(ref.exp, JSON.stringify(value));
            }
            else if (typeof value === "string") {
                template = template.replace(ref.exp, `"${value}"`);
            }
            else {
                template = template.replace(ref.exp, value);
            }
        }
        try {
            const value = (0, eval_1.safeEval)(template);
            return [ctx.path, value];
        }
        catch {
            return [ctx.path, undefined];
        }
    }
    getPropsToLog() {
        return (0, ramda_1.omit)(["template", "refs"], this.props);
    }
}
exports.ExpressionProvider = ExpressionProvider;
